import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import ModalButton from 'components/modals/modal_button';
import Checklist from 'components/lib/checklist';
import Modal from 'components/lib/modal';

class FbPagesSelectionModal extends React.Component {
  constructor(props) {
    super(props);

    _.bindAll(this, [
      'getModifiedFbPages',
      'getSelectedFbPageIds',
      'isAnyFbPageSelected',
      'onChange',
      'onClick',
      'renderChecklistModal',
      'renderEmptyFbPagesModal',
    ]);

    this.state = { fbPages: this.getModifiedFbPages() };
  }

  getModifiedFbPages() {
    return _.map(this.props.fbPages, fbPage => {
      return {
        value: fbPage.id,
        label: fbPage.name,
        isSelected: false,
      };
    });
  }

  render() {
    return (
      <div>
        {this.renderChecklistModal()}
        {this.renderEmptyFbPagesModal()}
      </div>
    );
  }

  renderChecklistModal() {
    if (!this.props.fbPages.length) {
      return null;
    }

    let isAnyFbPageSelected = this.isAnyFbPageSelected();
    let connectButtonClassNames = classnames('fbPagesSelectionModal-footer-connectButton', {
      'fbPagesSelectionModal-footer-connectButton-active': isAnyFbPageSelected,
      'fbPagesSelectionModal-footer-connectButton-inactive': !isAnyFbPageSelected,
    });

    return (
      <Modal className={classnames('fbPagesSelectionModal')}>
        <div className="fbPagesSelectionModal-container">
          <div className="fbPagesSelectionModal-header">{'Add Facebook Pages'}</div>
          <div className="fbPagesSelectionModal-body">
            {'Please select which Facebook Pages you would like to connect to Gladly'}
          </div>
          <div className="fbPagesSelectionModal-checklist">
            <Checklist options={this.state.fbPages} readOnly={false} onChange={this.onChange} />
          </div>
          <div className="fbPagesSelectionModal-checklist-gradient" />
        </div>
        <div className="fbPagesSelectionModal-footer">
          <ModalButton className="fbPagesSelectionModal-footer-cancelButton" onClick={this.props.onClose}>
            Cancel
          </ModalButton>
          <div className="fbPagesSelectionModal-footer-buttonDivider" />
          <ModalButton className={connectButtonClassNames} onClick={this.onClick}>
            Connect
          </ModalButton>
        </div>
      </Modal>
    );
  }

  renderEmptyFbPagesModal() {
    if (this.props.fbPages.length) {
      return null;
    }

    return (
      <Modal className={classnames('fbPagesSelectionModal')}>
        <div className="fbPagesSelectionModal-container">
          <div className="fbPagesSelectionModal-header">{'No Facebook Pages Found'}</div>
          <div className="fbPagesSelectionModal-body">{'This account does not appear to have any Facebook pages'}</div>
        </div>
        <div className="fbPagesSelectionModal-footer">
          <ModalButton className="fbPagesSelectionModal-footer-button" onClick={this.props.onClose}>
            Cancel
          </ModalButton>
        </div>
      </Modal>
    );
  }

  onClick() {
    if (!this.isAnyFbPageSelected()) {
      return;
    }

    this.props.onConfirm(this.getSelectedFbPageIds());
  }

  onChange(value, isSelected) {
    let fbPages = this.state.fbPages;
    let selectedFbPageIndex = _.findIndex(fbPages, fbPage => fbPage.value === value);
    _.assign(fbPages[selectedFbPageIndex], { isSelected });
    this.setState({ fbPages });
  }

  getSelectedFbPageIds() {
    let fbPages = this.state.fbPages;
    let selectedFbPages = _.filter(fbPages, fbPage => fbPage.isSelected);
    return _.map(selectedFbPages, selectedFbPage => selectedFbPage.value);
  }

  isAnyFbPageSelected() {
    return !!this.getSelectedFbPageIds().length;
  }
}

FbPagesSelectionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  fbPages: PropTypes.array.isRequired,
};

export default FbPagesSelectionModal;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/modals/fb_pages_selection_modal.jsx